import Image from '../../../generic/Image';
import { Link } from 'gatsby';
import React from 'react';
import RichText from '../../../generic/RichText';
import styles from './index.module.scss';

export default function BundledProducts({ products = [] }) {
  return !products || products.length < 1 ? null : (
    <div className={styles.bundled}>
      <p className={styles.bundledHeader}>Included with this product</p>
      <ul className={styles.bundledList}>
        {products.map(({ product, title, quantity }) => {
          const link = ['/devices', product.devicePage?.slug].join('/');
          return <BundledProduct key={title} product={product} quantity={quantity} link={link} />;
        })}
      </ul>
    </div>
  );
}

function BundledProduct({ product, link, quantity }) {
  return (
    <li className={styles.bundledItemWrapper}>
      <Link to={link} className={styles.bundledItem}>
        <div className={styles.bundledImageWrapper}>
          <Image
            fluid={product.images[0].image.fluid}
            alt={product.images[0].image.description}
            style={{ objectFit: 'contain' }}
          />
        </div>
        <div className={styles.bundledHeaderWrapper}>
          {`${quantity > 1 ? `${quantity} x ` : ''}`}
          <RichText>{product?.heading}</RichText>
        </div>
      </Link>
    </li>
  );
}
